import { useMutation, useQueryClient } from "react-query";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery"; 
import { request } from "utils/axios-utils";

// Hook to Fetch Records
export const useGetClinicalRecords = (patientId, type) => {
  return useCustomQuery(
    ["CLINICAL_RECORDS", patientId, type],
    {
        url: `/clinical-records/${patientId}?type=${type || ""}`,
        method: "get"
    },
    {
        refetchOnWindowFocus: false,
    }
  );
};

// Hook to Add Records
export const useAddClinicalRecord = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data) => request({
      url: "/clinical-records",
      method: "post",
      data: data,
    }),
    {
      onSuccess: (_, variables) => {
        // Invalidate queries to refresh the tables
        queryClient.invalidateQueries(["CLINICAL_RECORDS", variables.patientId]);
      },
    }
  );
};